import $ from "jquery";
import { useEffect, useState } from "react";

import { DunsMgrClaimCtaParameter } from "@/interfaces/CompanyProfile";
import { dnbComLog, LogSeverity, track_event } from "@/shared/FunctionCore";
import React from "react";



interface DunsMgrClaimCtaComponentPropertiesClient {
	"inAnchorsComponent": boolean;
}

type DunsMgrClaimCtaComponentProperties = DunsMgrClaimCtaComponentPropertiesClient & DunsMgrClaimCtaParameter;

const DunsMgrClaimCtaComponent = (props: DunsMgrClaimCtaComponentProperties): JSX.Element => {
	const {
		dunsMgrClaimCtaData,
		inAnchorsComponent
	} = props;
	const claimCompanyLinkRewritten = "https://www.dnb.com/duns-number/view-update-company-credit-file.html?companyDuns={{companyDuns}}.html";

	const {
		// claimCompanyLinkRewritten,
		claimed,
		enableDunsManagerClaimCompanyCta,
		organizationDunsEncrypted,
		organizationPrimaryName,
		properties,
		unclaimed,
		updateClaimedLinkRewritten
	} = dunsMgrClaimCtaData;

	const [circledIButtonOnLeft, setCircledIButtonOnLeft] = useState(true);
	const [clickToggleState, setClickToggleState] = useState(false);
	const [mouseOverTooltip, setMouseOverTooltip] = useState(false);

	useEffect(() => {
		const mediaQueryList = window.matchMedia("screen and (max-width: 767px)");

		const handleMediaQueryListMediaQueryListEvent = (me: MediaQueryList | MediaQueryListEvent) => setCircledIButtonOnLeft(!me.matches);

		mediaQueryList.addEventListener("change", (me) => handleMediaQueryListMediaQueryListEvent(me));

		handleMediaQueryListMediaQueryListEvent(mediaQueryList);

		$(window.document).on("click", (cl) => {
			// if (!$(cl.target).hasClass(classCombiner(styles, "iconTooltip")[1])) {
			if (!$(cl.target).hasClass("iconTooltip"[1])) {
				setClickToggleState(false);
			}
		});
	}, []);

	if (claimed! && unclaimed!) {
		dnbComLog(LogSeverity.ERROR, 'claimed" and "unclaimed" cannot both be true');
	}

	const showTooltip = clickToggleState || mouseOverTooltip;

	const claimedOrUnclaimed = () => {
		let claimCtaLink: string;
		let claimedStatusHeaderMessage: string;
		let claimStatusTooltipText: string;
		let clickEventName: string;
		let tooltipAriaLabel: string;

		if (claimed!) {
			claimCtaLink = updateClaimedLinkRewritten!;

			claimedStatusHeaderMessage = properties!["claimedBadgeText"];

			claimStatusTooltipText = properties!["claimedToolTipText"];

			clickEventName = "log_into_acct_clicked";

			tooltipAriaLabel = properties!["ariaLabelClaimedToolTip"];
		} else if (unclaimed!) {
			claimCtaLink = claimCompanyLinkRewritten!.replace("{{companyDuns}}", organizationDunsEncrypted!);

			claimedStatusHeaderMessage = properties!["claimCompanyBadgeText"];

			claimStatusTooltipText = properties!["claimCompanyToolTipText"];

			clickEventName = "create_duns_mgr_acct_clicked";

			tooltipAriaLabel = properties!["ariaLabelClaimCompanyToolTip"];
		} else {
			dnbComLog(LogSeverity.ERROR, 'Expecting either "claimed" or "unclaimed" to be true');
		}

		const claimCompanySId = properties!["claimCompanySId"];

		const claimStatusTooltipTextReplaced = claimStatusTooltipText.replace("{{dashboard_link_open}}", `<a href="${claimCtaLink}" target="_blank" rel="noreferrer">`).replace("{{dashboard_link_close}}", "</a>");

		const circledIButton = (onLeft: boolean) =>
			inAnchorsComponent ? (
				<></>
			) : (
				<div
					className={`dunsMgrClaimHeaderButtonCta ${onLeft ? 'onLeft' : 'onRight'}`}>
					<div className="iconTooltipOuterWrapper">
						<div
							className="iconTooltipWrapper"
							onMouseLeave={() => setMouseOverTooltip(false)}
						>
							<div
								aria-label={tooltipAriaLabel}
								className={`tooltipText ${claimed! ? "claimed" : "unclaimed"} ${showTooltip ? "isVisible" : void 0}`}
								dangerouslySetInnerHTML={{ "__html": claimStatusTooltipTextReplaced }}
								role="img" />
						</div>

						<button
							className="iconTooltip"
							onClick={() => {
								setClickToggleState((bo) => {
									if (bo) {
										setMouseOverTooltip(false);
									}

									return !bo;
								});
							}}
							onMouseEnter={() => {
								setMouseOverTooltip(true);
							}}
							type="button"
						/>
					</div>
				</div>
			);

		const claimedButtonOrClaimLink = () =>
			claimed! ? (
				<button
					className="claimedCompany"
					type="button">
					<span className="claimedStatusHeaderMessage">
						{claimedStatusHeaderMessage}
					</span>

					<span className="iconClaimedCheck" />
				</button>
			) : (
				<a
					className="claimThisCompany"
					href={claimCtaLink}
					onClick={() => track_event(`${organizationPrimaryName} - ${clickEventName}`)}
				>
					{claimedStatusHeaderMessage}
				</a>
			);

		return (
			<div
				className={`dunsMgrClaimCtaWrapper ${inAnchorsComponent ? 'inAnchorsComponent' : void 0}`}
				data-id={claimCompanySId}
			>
				{circledIButtonOnLeft ? (
					<>
						{
							circledIButton(true)
						}

						{
							claimedButtonOrClaimLink()
						}
					</>
				) : (
					<>
						{
							claimedButtonOrClaimLink()
						}

						{
							circledIButton(false)
						}
					</>
				)}
			</div>
		);
	};

	// return !claimed! && !unclaimed! || enableDunsManagerClaimCompanyCta !== "true" ? <span
	return (!claimed! && !unclaimed!) || (enableDunsManagerClaimCompanyCta !== "true") ? <span
		dangerouslySetInnerHTML={{
			"__html": `
<!--
    Skipping DunsMgrClaimCta component because company does not qualify as either claimed or unclaimed, or because enableDunsManagerClaimCompanyCTA is not "true"
-->`,
		}}
		style={{ "display": "none" }}
	/> : claimedOrUnclaimed();
};

// const dunsMgrClaimCta = (renderableData: RenderableData<DunsMgrClaimCtaParameter>): void =>
//     renderIdentifierGeneric(
//         DunsMgrClaimCtaComponent,
//         addToRenderableData(
//             renderableData,
//             {
//                 "inAnchorsComponent": false
//             }
//         ));

// export {dunsMgrClaimCta, DunsMgrClaimCtaComponent, DunsMgrClaimCtaComponentProperties};
export { DunsMgrClaimCtaComponent, DunsMgrClaimCtaComponentProperties }
